/*=========================================================================================
  File Name: moduleEcommerceState.js
  Description: Ecommerce Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
   companyID: '',
   companyName: '',
   apiID: '',
   latitude: '',
   longitude: '',
   wallet_amount: 0,
   total_users: 0,
   companies: [],
}
